// Contact Page Component with EmailJS Integration for Bringright International
import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import PageHeader from '../components/PageHeader';

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    company: '',
    country: '',
    service: '',
    subject: '',
    message: '',
    newsletter: false,
    privacy: false
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });
  // service_8qkmvsq
  // Initialize EmailJS
  useEffect(() => {
    // Initialize EmailJS with your public key
    emailjs.init("E9WPe5MAjEMyKynhx"); // Replace with your actual public key
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ type: '', message: '' });

    try {
      // Prepare template parameters
      const templateParams = {
        from_name: `${formData.firstName} ${formData.lastName}`,
        from_email: formData.email,
        to_email: 'contact@bringrightinternational.com',
        subject: formData.subject,
        message: formData.message,
        phone: formData.phone || 'Not provided',
        company: formData.company || 'Not provided',
        country: formData.country || 'Not provided',
        service: formData.service || 'Not specified',
        newsletter: formData.newsletter ? 'Yes' : 'No',
        submission_date: new Date().toLocaleString('en-IN', {
          timeZone: 'Asia/Kolkata',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      };

      // Send email using EmailJS
      const result = await emailjs.send(
        'service_8qkmvsq', // Replace with your EmailJS service ID
        'template_ult59hi', // Replace with your EmailJS template ID
        templateParams
      );

      if (result.status === 200) {
        setSubmitStatus({
          type: 'success',
          message: 'Thank you for your message! We will get back to you soon.'
        });

        // Reset form
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          company: '',
          country: '',
          service: '',
          subject: '',
          message: '',
          newsletter: false,
          privacy: false
        });
      }
    } catch (error) {
      console.error('EmailJS Error:', error);
      setSubmitStatus({
        type: 'error',
        message: 'Sorry, there was an error sending your message. Please try again or contact us directly.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      {/* Page Header */}
      <PageHeader
        title="Get in Touch"
        subtitle="Ready to expand your global reach? Let's discuss how we can help your business grow internationally"
        breadcrumbItems={[
          { label: 'Home', href: '#' },
          { label: 'Contact Us' }
        ]}
        showStats={false}
      />

      {/* Contact Information Section */}
      <section className="contact-info-section py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="section-title">Get In Touch With Us</h2>
            <p className="section-subtitle">We're here to help you with all your global trade needs</p>
          </div>

          <div className="row g-4 mb-5">
            <div className="col-lg-4 col-md-6">
              <div className="contact-card text-center">
                <div className="contact-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <h4>Visit Our Office</h4>
                <p>YASHLAXMI S.NO. 54, NEAR PRANIT COMPUTER<br />
                Karvenagar, Pune, Maharashtra<br />
                India, 411052</p>
                <a href="https://maps.app.goo.gl/x8REExfiT8a7b4Ae9" target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary btn-sm">
                  <i className="fas fa-directions me-1"></i>Get Directions
                </a>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="contact-card text-center">
                <div className="contact-icon">
                  <i className="fas fa-phone-alt"></i>
                </div>
                <h4>Call Us</h4>
                <p>Phone: <a href="tel:+919975349144">+91 9975349144</a><br />
                <a href="tel:+918888653131">+91 8888653131</a><br />
                <a href="tel:+919579670950">+91 9579670950</a></p>
                <a href="tel:+919975349144" className="btn btn-outline-primary btn-sm">
                  <i className="fas fa-phone me-1"></i>Call Now
                </a>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="contact-card text-center">
                <div className="contact-icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <h4>Email Us</h4>
                <p>General: <a href="mailto:contact@bringrightinternational.com">contact@bringrightinternational.com</a><br />
                Sales: <a href="mailto:sales@bringrightinternational.com">sales@bringrightinternational.com</a><br />
                Support: <a href="mailto:support@bringrightinternational.com">support@bringrightinternational.com</a>
                </p>
                <a href="mailto:contact@bringrightinternational.com" className="btn btn-outline-primary btn-sm">
                  <i className="fas fa-envelope me-1"></i>Send Email
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contact-form-section py-5 bg-light">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-8">
              <div className="contact-form-wrapper">
                <h3 className="mb-4">Send Us a Message</h3>
                
                {/* Status Messages */}
                {submitStatus.message && (
                  <div className={`alert ${submitStatus.type === 'success' ? 'alert-success' : 'alert-danger'} mb-4`}>
                    <i className={`fas ${submitStatus.type === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle'} me-2`}></i>
                    {submitStatus.message}
                  </div>
                )}

                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label htmlFor="firstName" className="form-label">First Name *</label>
                      <input 
                        type="text" 
                        className="form-control" 
                        id="firstName" 
                        name="firstName" 
                        value={formData.firstName}
                        onChange={handleInputChange}
                        required 
                        disabled={isSubmitting}
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="lastName" className="form-label">Last Name *</label>
                      <input 
                        type="text" 
                        className="form-control" 
                        id="lastName" 
                        name="lastName" 
                        value={formData.lastName}
                        onChange={handleInputChange}
                        required 
                        disabled={isSubmitting}
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="email" className="form-label">Email Address *</label>
                      <input 
                        type="email" 
                        className="form-control" 
                        id="email" 
                        name="email" 
                        value={formData.email}
                        onChange={handleInputChange}
                        required 
                        disabled={isSubmitting}
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="phone" className="form-label">Phone Number</label>
                      <input 
                        type="tel" 
                        className="form-control" 
                        id="phone" 
                        name="phone" 
                        value={formData.phone}
                        onChange={handleInputChange}
                        disabled={isSubmitting}
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="company" className="form-label">Company Name</label>
                      <input 
                        type="text" 
                        className="form-control" 
                        id="company" 
                        name="company" 
                        value={formData.company}
                        onChange={handleInputChange}
                        disabled={isSubmitting}
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="country" className="form-label">Country</label>
                      <select 
                        className="form-select" 
                        id="country" 
                        name="country"
                        value={formData.country}
                        onChange={handleInputChange}
                        disabled={isSubmitting}
                      >
                        <option value="">Select Country</option>
                        <option value="IN">India</option>
                        <option value="US">United States</option>
                        <option value="UK">United Kingdom</option>
                        <option value="DE">Germany</option>
                        <option value="FR">France</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                    <div className="col-12">
                      <label htmlFor="service" className="form-label">Service Interest</label>
                      <select 
                        className="form-select" 
                        id="service" 
                        name="service"
                        value={formData.service}
                        onChange={handleInputChange}
                        disabled={isSubmitting}
                      >
                        <option value="">Select Service</option>
                        <option value="import">Import Services</option>
                        <option value="export">Export Services</option>
                        <option value="logistics">Logistics Management</option>
                        <option value="consultation">Trade Consultation</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                    <div className="col-12">
                      <label htmlFor="subject" className="form-label">Subject *</label>
                      <input 
                        type="text" 
                        className="form-control" 
                        id="subject" 
                        name="subject" 
                        value={formData.subject}
                        onChange={handleInputChange}
                        required 
                        disabled={isSubmitting}
                      />
                    </div>
                    <div className="col-12">
                      <label htmlFor="message" className="form-label">Message *</label>
                      <textarea 
                        className="form-control" 
                        id="message" 
                        name="message" 
                        rows="6" 
                        value={formData.message}
                        onChange={handleInputChange}
                        required 
                        placeholder="Please provide details about your inquiry..."
                        disabled={isSubmitting}
                      ></textarea>
                    </div>
                    <div className="col-12">
                      <div className="form-check">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="newsletter" 
                          name="newsletter"
                          checked={formData.newsletter}
                          onChange={handleInputChange}
                          disabled={isSubmitting}
                        />
                        <label className="form-check-label" htmlFor="newsletter">
                          Subscribe to our newsletter for trade insights and updates
                        </label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-check">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id="privacy" 
                          name="privacy"
                          checked={formData.privacy}
                          onChange={handleInputChange}
                          required 
                          disabled={isSubmitting}
                        />
                        <label className="form-check-label" htmlFor="privacy">
                          I agree to the Privacy Policy and Terms of Service *
                        </label>
                      </div>
                    </div>
                    <div className="col-12">
                      <button type="submit" className="btn btn-primary btn-lg" disabled={isSubmitting}>
                        {isSubmitting ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Sending...
                          </>
                        ) : (
                          <>
                            <i className="fas fa-paper-plane me-2"></i>Send Message
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="col-lg-4">
              {/* WhatsApp Card */}
              <div className="whatsapp-card mb-4">
                <div className="card h-100">
                  <div className="card-body text-center">
                    <div className="whatsapp-icon mb-3">
                      <i className="fab fa-whatsapp"></i>
                    </div>
                    <h5>WhatsApp Support</h5>
                    <p>Get instant support and quick responses to your queries</p>
                    <a href="https://wa.me/919975349144" target="_blank" rel="noopener noreferrer" className="btn btn-success btn-lg w-100">
                      <i className="fab fa-whatsapp me-2"></i>Start WhatsApp Chat
                    </a>
                    <small className="text-muted d-block mt-2">Available 24/7</small>
                  </div>
                </div>
              </div>

              {/* Office Hours */}
              <div className="office-hours-card">
                <div className="card h-100">
                  <div className="card-body">
                    <h5 className="card-title">
                      <i className="fas fa-clock me-2"></i>Office Hours
                    </h5>
                    <ul className="list-unstyled office-hours">
                      <li><strong>Monday - Friday:</strong> 9:00 AM - 6:00 PM</li>
                      <li><strong>Saturday:</strong> 9:00 AM - 2:00 PM</li>
                      <li><strong>Sunday:</strong> Closed</li>
                    </ul>
                    <div className="timezone-info">
                      <small className="text-muted">
                        <i className="fas fa-globe me-1"></i>Indian Standard Time (IST)
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Google Map Section */}
      <section className="map-section">
        <div className="container-fluid p-0">
          <div className="map-wrapper">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.2674633970143!2d73.85438997496152!3d18.520430282557866!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bf2e67461101%3A0x828d43bf9d9ee343!2sKarve%20Nagar%2C%20Pune%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1703123456789!5m2!1sen!2sin" 
              width="100%" 
              height="400" 
              style={{border: 0}} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="BRINGRIGHT International Office Location"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;